<app-popin (closeOutput)="emitNoContinue()" [show]="show">
  <h1 class="text-dark text-center font-18 font-md-24">
    {{ "popin_abandon_accounts_title" | translate }}
  </h1>

  <p
    class="text-center"
    [innerHTML]="'popin_abandon_accounts_first_paragraph' | translate"
  ></p>
  <p
    class="text-center"
    [innerHTML]="'popin_abandon_accounts_second_paragraph' | translate"
  ></p>

  <div class="d-flex justify-center">
    <button
      (click)="emitYesAbandon()"
      class="btn bg-transparent border-primary text-primary rounded-full px-5 m-2"
    >
      {{ "common_yes" | translate }}
      <span class="d-none d-md-inline">
        {{ "popin_abandon_accounts_yes_button_abandon" | translate }}</span
      >
    </button>

    <button
      (click)="emitNoContinue()"
      class="btn bg-primary rounded-full px-5 m-2"
    >
      {{ "common_no" | translate }}
      <span class="d-none d-md-inline">
        {{ "popin_abandon_accounts_no_button_continue" | translate }}</span
      >
    </button>
  </div>
</app-popin>
